/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Meta_TitleInputs */

const id_meta_title = /** @type {(inputs: Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Database Epic Games - egdata.app`)
};

const ms_meta_title = /** @type {(inputs: Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pangkalan Data Epic Games - egdata.app`)
};

const da_meta_title = /** @type {(inputs: Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Epic Games Database - egdata.app`)
};

const de_meta_title = /** @type {(inputs: Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Epic Games Datenbank - egdata.app`)
};

const en_us2_meta_title = /** @type {(inputs: Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Epic Games Database - egdata.app`)
};

const es_es2_meta_title = /** @type {(inputs: Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Base de datos de Epic Games - egdata.app`)
};

const es_mx2_meta_title = /** @type {(inputs: Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Base de datos de Epic Games - egdata.app`)
};

const fil_meta_title = /** @type {(inputs: Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Epic Games Database - egdata.app`)
};

const fr_meta_title = /** @type {(inputs: Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Base de données Epic Games - egdata.app`)
};

const it_meta_title = /** @type {(inputs: Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Database Epic Games - egdata.app`)
};

const hu_meta_title = /** @type {(inputs: Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Epic Games Adatbázis - egdata.app`)
};

const nl_meta_title = /** @type {(inputs: Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Epic Games Database - egdata.app`)
};

const no_meta_title = /** @type {(inputs: Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Epic Games Database - egdata.app`)
};

const pl_meta_title = /** @type {(inputs: Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Baza danych Epic Games - egdata.app`)
};

const pt_br2_meta_title = /** @type {(inputs: Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Base de dados da Epic Games - egdata.app`)
};

const pt_meta_title = /** @type {(inputs: Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Base de Dados Epic Games - egdata.app`)
};

const ro_meta_title = /** @type {(inputs: Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Baza de date Epic Games - egdata.app`)
};

const fi_meta_title = /** @type {(inputs: Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Epic Games -tietokanta - egdata.app`)
};

const sv_meta_title = /** @type {(inputs: Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Epic Games-databas - egdata.app`)
};

const vi_meta_title = /** @type {(inputs: Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cơ sở dữ liệu Epic Games - egdata.app`)
};

const tr_meta_title = /** @type {(inputs: Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Epic Games Veritabanı - egdata.app`)
};

const cs_meta_title = /** @type {(inputs: Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Databáze Epic Games - egdata.app`)
};

const bg_meta_title = /** @type {(inputs: Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`База данни на Epic Games - egdata.app`)
};

const ru_meta_title = /** @type {(inputs: Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`База данных Epic Games — egdata.app`)
};

const uk_meta_title = /** @type {(inputs: Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`База даних Epic Games - egdata.app`)
};

const ar_meta_title = /** @type {(inputs: Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`قاعدة بيانات Epic Games - egdata.app`)
};

const hi_meta_title = /** @type {(inputs: Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Epic Games डेटाबेस - egdata.app`)
};

const th_meta_title = /** @type {(inputs: Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ฐานข้อมูล Epic Games - egdata.app`)
};

const ja_meta_title = /** @type {(inputs: Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Epic Games データベース - egdata.app`)
};

const zh_cn2_meta_title = /** @type {(inputs: Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Epic游戏数据库 - egdata.app`)
};

const zh_hant1_meta_title = /** @type {(inputs: Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Epic遊戲資料庫 - egdata.app`)
};

const ko_meta_title = /** @type {(inputs: Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Epic Games 데이터베이스 - egdata.app`)
};

/**
* | output |
* | --- |
* | "Epic Games Database - egdata.app" |
*
* @param {Meta_TitleInputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const meta_title = /** @type {((inputs?: Meta_TitleInputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Meta_TitleInputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_meta_title(inputs)
	if (locale === "ms") return ms_meta_title(inputs)
	if (locale === "da") return da_meta_title(inputs)
	if (locale === "de") return de_meta_title(inputs)
	if (locale === "en-US") return en_us2_meta_title(inputs)
	if (locale === "es-ES") return es_es2_meta_title(inputs)
	if (locale === "es-MX") return es_mx2_meta_title(inputs)
	if (locale === "fil") return fil_meta_title(inputs)
	if (locale === "fr") return fr_meta_title(inputs)
	if (locale === "it") return it_meta_title(inputs)
	if (locale === "hu") return hu_meta_title(inputs)
	if (locale === "nl") return nl_meta_title(inputs)
	if (locale === "no") return no_meta_title(inputs)
	if (locale === "pl") return pl_meta_title(inputs)
	if (locale === "pt-BR") return pt_br2_meta_title(inputs)
	if (locale === "pt") return pt_meta_title(inputs)
	if (locale === "ro") return ro_meta_title(inputs)
	if (locale === "fi") return fi_meta_title(inputs)
	if (locale === "sv") return sv_meta_title(inputs)
	if (locale === "vi") return vi_meta_title(inputs)
	if (locale === "tr") return tr_meta_title(inputs)
	if (locale === "cs") return cs_meta_title(inputs)
	if (locale === "bg") return bg_meta_title(inputs)
	if (locale === "ru") return ru_meta_title(inputs)
	if (locale === "uk") return uk_meta_title(inputs)
	if (locale === "ar") return ar_meta_title(inputs)
	if (locale === "hi") return hi_meta_title(inputs)
	if (locale === "th") return th_meta_title(inputs)
	if (locale === "ja") return ja_meta_title(inputs)
	if (locale === "zh-CN") return zh_cn2_meta_title(inputs)
	if (locale === "zh-Hant") return zh_hant1_meta_title(inputs)
	return ko_meta_title(inputs)
});
export { meta_title as "meta.title" }